/* unplugin-vue-components disabled */import { render } from "./bigImage.vue?vue&type=template&id=23d1f332&scoped=true"
import script from "./bigImage.vue?vue&type=script&lang=js"
export * from "./bigImage.vue?vue&type=script&lang=js"

import "./bigImage.vue?vue&type=style&index=0&id=23d1f332&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d1f332"]])

export default __exports__